// Conta produtos distintos já comprados. Para assinante dos dois clubes a API devolve
// o mesmo produto uma vez por campanha (Curadoria e Inéditos), então contar linhas
// dobraria as compras e bloquearia o limite antes da hora.
export const contarOpcionaisComprados = produtos => {
  const idsComprados = produtos
    .filter( produto => produto.vendas.length )
    .map( produto => produto.id )

  return new Set( idsComprados ).size
}
